import { Action } from 'redux';

export const UPDATE_SELECTED_RECORDS = '@@temp/UPDATE_SELECTED_RECORDS';
export type T_UPDATE_SELECTED_RECORDS = typeof UPDATE_SELECTED_RECORDS;

export interface UpdateSelectedRecords extends Action {
	type: T_UPDATE_SELECTED_RECORDS;
	collection: string;
	recordId: string;
	selected: boolean;
}

export const updateSelectedRecords = (collection: string, recordId: string, selected: boolean): UpdateSelectedRecords => {
	return {
		type: UPDATE_SELECTED_RECORDS,
		collection,
		recordId,
		selected,
	};
};

export const CLEAR_SELECTED_RECORDS = '@@temp/CLEAR_SELECTED_RECORDS';
export type T_CLEAR_SELECTED_RECORDS = typeof CLEAR_SELECTED_RECORDS;

export interface ClearSelectedRecords extends Action {
	type: T_CLEAR_SELECTED_RECORDS;
	collection: string;
}

export const clearSelectedRecords = (collection: string): ClearSelectedRecords => {
	return {
		type: CLEAR_SELECTED_RECORDS,
		collection,
	};
};
